import { render, staticRenderFns } from "./Step.vue?vue&type=template&id=12d0c638&scoped=true&"
import script from "./Step.vue?vue&type=script&lang=ts&"
export * from "./Step.vue?vue&type=script&lang=ts&"
import style0 from "./Step.vue?vue&type=style&index=0&id=12d0c638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d0c638",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-cfm/mfe-cfm/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12d0c638')) {
      api.createRecord('12d0c638', component.options)
    } else {
      api.reload('12d0c638', component.options)
    }
    module.hot.accept("./Step.vue?vue&type=template&id=12d0c638&scoped=true&", function () {
      api.rerender('12d0c638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/steps/Step.vue"
export default component.exports